const API_URL = 'https://sigohrmlpadmin.loopring.in/api/'


const BASE_URL =   ""    
const FRONT_URL =   "http://localhost:3000/"    
const DEFAULT_IMAGE="/images/logo.png"
const META_DEFAULT_IMAGE=""

const TESTIMONIAL_IMAGE="/images/testimonial.png"

export default { API_URL,BASE_URL,FRONT_URL,DEFAULT_IMAGE,TESTIMONIAL_IMAGE,META_DEFAULT_IMAGE };